// helpers
import VScope from '../components/helpers/v-scope.vue';
import VSource from '../components/helpers/v-source.vue';
import VModelSource from '../components/helpers/v-model-source.vue';
import VLoader from '../components/helpers/v-loader.vue';
import VSvgIcon from '../components/helpers/v-svg-icon.vue';
import VImage from '../components/helpers/v-image.vue';
import VVideo from '../components/helpers/v-video.vue';
import VLazyComponent from '../components/helpers/v-lazy-component.vue';

// plugins
import VSwiperSlider from '../components/v-swiper-slider.vue'; // https://swiperjs.com/vue/
import VueCropper from 'vue-cropperjs';

// forms
import VForm from '../components/v-form.vue';
import VField from '../components/v-field.vue';
import VFieldText from '../components/v-field-text.vue';
import VFieldSelect from '../components/v-field-select.vue';
import VFieldMultiSelect from '../components/v-field-multi-select.vue';
import VFieldCheckbox from '../components/v-field-checkbox.vue';
import VFieldCheckList from '../components/v-field-check-list.vue';
import VFieldTumbler from '../components/v-field-tumbler.vue';
import VFieldTumblerList from '../components/v-field-tumbler-list.vue';
import VFieldCount from '../components/v-field-count.vue';
import VFieldRange from '../components/v-field-range.vue';
import VFieldRangeSlider from '../components/v-field-range-slider.vue';
import VFieldFile from '../components/v-field-file.vue';
import VFieldViewPicker from '../components/v-field-view-picker.vue';
import VFieldTel from '../components/v-field-tel.vue';
import VFieldCode from "../components/v-field-code.vue";
import VRating from '../components/v-rating.vue';
import VDatepicker from '../components/v-datepicker.vue';
import VPriceRanger from '../components/v-price-ranger.vue';
import VTabsSelect from '../components/v-tabs-select.vue';
import VFieldModalSelect from '../components/v-field-modal-select.vue';
import VFieldModalSelectMultiple from '../components/v-field-modal-select-multiple.vue';
import VFieldPromocode from '../components/v-field-promocode.vue';
import VFieldMap from "../components/v-field-map.vue";
import VfieldAvatar from '../components/v-field-avatar.vue'
import VFieldToggler from '../components/v-field-toggler.vue';
import VAddEmployeeForm from "../components/v-add-employee-form.vue";
import VFieldTranslateList from "../components/v-field-translate-list.vue";
import VFieldCustomCheckbox from "../components/v-field-custom-checkbox.vue";
import VFieldSchedule from "../components/v-field-schedule.vue";
import VFieldSelectTime from "../components/v-field-select-time.vue";
import VFieldContacts from "../components/v-field-contacts.vue";
import VFieldTelEdit from "../components/v-field-tel-edit.vue";
import VFieldTypePicker from "../components/v-field-type-picker.vue";
import VFieldDoubleText from "../components/v-field-double-text.vue";
import VFieldPageSelect from "../components/v-field-page-select.vue";
import VFieldWorkSchedule from "../components/v-field-work-schedule.vue";

// blocks
import VPageSection from '../components/v-page-section.vue';
import VPageSectionHeader from '../components/v-page-section-header.vue';
import VHeroBlock from '../components/v-hero-block.vue';
import VHeroSlider from '../components/v-hero-slider.vue';
import VPrice from '../components/v-price.vue';
import VStatus from '../components/v-status.vue';
import VCatalog from '../components/v-catalog.vue';
import VCatalogCompare from '../components/v-catalog-compare.vue';
import VCollapse from '../components/v-collapse.vue';
import VBasket from '../components/v-basket.vue';
import VFilter from '../components/v-filter.vue';
import VFilterActiveItems from '../components/v-filter-active-items.vue';
import VPageNav from '../components/v-page-nav.vue';
import VAvailability from '../components/v-availability.vue';
import VTopNav from '../components/v-top-nav.vue';
import VMainNav from '../components/v-main-nav.vue';
import VMobileNav from '../components/v-mobile-nav.vue';
import VPageHeader from '../components/v-page-header.vue';
import VBasketSmall from '../components/v-basket-small.vue';
import VBasketAction from '../components/v-basket-action.vue';
import VCompareAction from '../components/v-compare-action.vue';
import VFavoriteSmall from '../components/v-favorite-small.vue';
import VFavoriteAction from '../components/v-favorite-action.vue';
import VCompareSmall from '../components/v-compare-small.vue';
import VProductGrid from '../components/v-product-grid.vue';
import VProductList from '../components/v-product-list.vue';
import VProductLine from '../components/v-product-line.vue';
import VProductSlider from '../components/v-product-slider.vue';
import VImageSlider from '../components/v-image-slider.vue';
import VProduct from '../components/v-product.vue';
import VProductImage from '../components/v-product-image.vue';
import VArticleGrid from '../components/v-article-grid.vue';
import VArticlePoster from '../components/v-article-poster.vue';
import VCatalogItem from '../components/v-catalog-item.vue';
import VSearchSmall from '../components/v-search-small.vue';
import VModal from '../components/v-modal.vue';
import VModalWindow from '../components/v-modal-window.vue';
import VGallery from '../components/v-gallery.vue';
import VMap from '../components/v-map.vue';
import VLocationPicker from '../components/v-location-picker.vue';
import VContactsList from '../components/v-contacts-list.vue';
import VNotifications from '../components/v-notifications.vue';
import VPageFooter from '../components/v-page-footer.vue';
import VBreadcrumbs from '../components/v-breadcrumbs.vue';
import VTabs from '../components/v-tabs.vue';
import VNewSlider from '../components/v-new-slider.vue';
import VPageSectionProjects from '../components/v-page-section-projects.vue';
import VPageSectionLinks from "../components/v-page-section-links.vue";
import VPageSectionSpecialist from "../components/v-page-section-specialist.vue";
import VPageSectionOptions from "../components/v-page-section-options.vue";
import VTopNavRight from "../components/v-top-nav-right.vue";
import VPageSectionMain from "../components/v-page-section-main.vue";
import VMainFilter from "../components/v-main-filter.vue";
import VCatalogSale from "../components/v-catalog-sale.vue";
import VSmallSlider from "../components/v-small-slider.vue";
import VHelp from "../components/v-help.vue";
import VAccordion from "../components/v-accordion.vue";
import VFavorite from "../components/v-favorite.vue";
import VSectionSlider from "../components/v-section-slider.vue";
import VAbout from "../components/v-about.vue";
import VContacts from "../components/v-contacts.vue";
import VDetailPage from "../components/v-detail-page.vue";
import VPageFooterInfo from "../components/page-footer-info.vue";
import VPageFooterItems from "../components/page-footer-items.vue";
import VPageFooterContacts from "../components/page-footer-contacts.vue";
import VImageSliderVertical from "../components/v-image-slider-vertical.vue";
import VImageSliderHorizontal from "../components/v-image-slider-horizontal.vue";
import VImageSliderGallery from "../components/v-image-slider-gallery.vue";
import VBillPromo from "../components/v-bill-promo.vue";
import VMediaContent from "../components/v-media-content.vue";
import VTermsBox from "../components/v-terms-box.vue";
import VTabsRequest from "../components/v-tabs-request.vue";
import VAuth from "../components/v-auth.vue";
import VAdvertiserChoice from "../components/v-advertiser-choice.vue";
import VMortgage from "../components/v-mortgage.vue";
import VModalSelectMultiple from "../components/v-modal-select-multiple.vue"
import VModalSelect from "../components/v-modal-select.vue";
import VPageBanner from "../components/v-page-banner.vue";
import VInternalNav from "../components/v-internal-nav.vue";
import VProfile from "../components/v-profile.vue";
import VLkAds from "../components/v-lk-ads.vue";
import VAds from "../components/v-ads.vue";
import VFieldTableSort from "../components/v-field-table-sort.vue";
import VPageHeaderLk from "../components/v-page-header-lk.vue";
import VLkPayment from "../components/v-lk-payment.vue";
import VPayment from "../components/v-payment.vue";
import VLkNotifications from "../components/v-lk-notifications.vue";
import VLkPaymentDetail from "../components/v-lk-payment-detail.vue";
import VCatalogSpecialist from "../components/v-catalog-specialist.vue";
import VMapGoogle from "../components/v-map-google.vue";
import VDetailSpecialist from "../components/v-detail-specialist.vue";
import VRadioList from "../components/v-radio-list.vue";
import VNotFound from "../components/v-not-found.vue";
import VAdsBuilder from "../components/v-ads-builder.vue";
import VConfirmLocationModal from "../components/v-confirm-location-modal.vue";
import VLkEmployees from "../components/v-lk-employees.vue";
import VLkEmployeesCard from "../components/v-lk-employees-card.vue";
import VNotFoundId from "../components/v-not-found-id.vue";
import VConfirmModal from "../components/v-confirm-modal.vue";
import VAddContactForm from "../components/v-add-contact-form.vue";
import VModalSuccess from "../components/v-modal-success.vue";
import VFieldGroup from "../components/v-field-group.vue";
import VCroppImage from "../components/v-cropp-image.vue";
import VMapFilter from "../components/v-map-filter.vue";
import VModalMap from "../components/v-modal-map.vue";
import VModalCookie from "../components/v-modal-cookie.vue";
import VMobileNavBar from "../components/v-mobile-nav-bar.vue";

export default {
	// helpers
	'v-scope': VScope,
	'v-source': VSource,
	'v-model-source': VModelSource,
	'v-loader': VLoader,
	'v-svg-icon': VSvgIcon,
	'v-image': VImage,
	'v-video': VVideo,
	'v-lazy-component': VLazyComponent,

	// plugins
	'v-swiper-slider': VSwiperSlider,
	'VueCropper': VueCropper,

	// forms
	'v-form': VForm,
	'v-field': VField,
	'v-field-text': VFieldText,
	'v-field-select': VFieldSelect,
	'v-field-multi-select': VFieldMultiSelect,
	'v-field-checkbox': VFieldCheckbox,
	'v-field-check-list': VFieldCheckList,
	'v-field-tumbler': VFieldTumbler,
	'v-field-tumbler-list': VFieldTumblerList,
	'v-field-count': VFieldCount,
	'v-field-range': VFieldRange,
	'v-field-range-slider': VFieldRangeSlider,
	'v-field-file': VFieldFile,
	'v-field-view-picker': VFieldViewPicker,
	'v-field-tel': VFieldTel,
	'v-field-code': VFieldCode,
	'v-rating': VRating,
	'v-datepicker': VDatepicker,
	'v-price-ranger': VPriceRanger,
	'v-tabs-select': VTabsSelect,
	'v-field-modal-select': VFieldModalSelect,
	'v-field-modal-select-multiple': VFieldModalSelectMultiple,
	'v-field-avatar': VfieldAvatar,
	'v-field-toggler': VFieldToggler,
	'v-field-table-sort': VFieldTableSort,
	'v-field-promocode': VFieldPromocode,
	'v-add-employee-form': VAddEmployeeForm,
	'v-field-map': VFieldMap,
	'v-field-translate-list': VFieldTranslateList,
	'v-field-custom-checkbox': VFieldCustomCheckbox,
	'v-field-contacts': VFieldContacts,
	'v-field-tel-edit': VFieldTelEdit,
	'v-field-schedule': VFieldSchedule,
	'v-field-select-time': VFieldSelectTime,
	'v-field-type-picker': VFieldTypePicker,
	'v-field-group': VFieldGroup,
	'v-field-double-text': VFieldDoubleText,
	'v-field-page-select': VFieldPageSelect,
	'v-field-work-schedule': VFieldWorkSchedule,

	// blocks
	'v-page-section': VPageSection,
	'v-page-section-header': VPageSectionHeader,
	'v-hero-block': VHeroBlock,
	'v-hero-slider': VHeroSlider,
	'v-price': VPrice,
	'v-status': VStatus,
	'v-catalog': VCatalog,
	'v-catalog-compare': VCatalogCompare,
	'v-collapse': VCollapse,
	'v-basket': VBasket,
	'v-filter': VFilter,
	'v-filter-active-items': VFilterActiveItems,
	'v-page-nav': VPageNav,
	'v-availability': VAvailability,
	'v-top-nav': VTopNav,
	'v-main-nav': VMainNav,
	'v-mobile-nav': VMobileNav,
	'v-page-header': VPageHeader,
	'v-basket-small': VBasketSmall,
	'v-basket-action': VBasketAction,
	'v-compare-action': VCompareAction,
	'v-favorite-small': VFavoriteSmall,
	'v-favorite-action': VFavoriteAction,
	'v-compare-small': VCompareSmall,
	'v-product-grid': VProductGrid,
	'v-product-list': VProductList,
	'v-product-line': VProductLine,
	'v-product-slider': VProductSlider,
	'v-image-slider': VImageSlider,
	'v-product': VProduct,
	'v-product-image': VProductImage,
	'v-article-grid': VArticleGrid,
	'v-article-poster': VArticlePoster,
	'v-catalog-item': VCatalogItem,
	'v-search-small': VSearchSmall,
	'v-modal': VModal,
	'v-modal-window': VModalWindow,
	'v-gallery': VGallery,
	'v-map': VMap,
	'v-location-picker': VLocationPicker,
	'v-contacts-list': VContactsList,
	'v-notifications': VNotifications,
	'v-page-footer': VPageFooter,
	'v-breadcrumbs': VBreadcrumbs,
	'v-tabs': VTabs,
	'v-new-slider': VNewSlider,
	'v-page-section-projects': VPageSectionProjects,
	'v-page-section-links': VPageSectionLinks,
	'v-page-section-specialist': VPageSectionSpecialist,
	'v-page-section-options': VPageSectionOptions,
	'v-top-nav-right': VTopNavRight,
	'v-page-section-main': VPageSectionMain,
	'v-main-filter': VMainFilter,
	'v-catalog-sale': VCatalogSale,
	'v-small-slider': VSmallSlider,
	'v-help': VHelp,
	'v-accordion.vue': VAccordion,
	'v-favorite': VFavorite,
	'v-section-slider': VSectionSlider,
	'v-about': VAbout,
	'v-contacts': VContacts,
	'v-detail-page': VDetailPage,
	'v-page-footer-info': VPageFooterInfo,
	'v-page-footer-items': VPageFooterItems,
	'v-page-footer-contacts': VPageFooterContacts,
	'v-image-slider-vertical': VImageSliderVertical,
	'v-image-slider-horizontal': VImageSliderHorizontal,
	'v-image-slider-gallery': VImageSliderGallery,
	'v-bill-promo': VBillPromo,
	'v-media-content': VMediaContent,
	'v-terms-box': VTermsBox,
	'v-tabs-request': VTabsRequest,
	'v-auth': VAuth,
	'v-advertiser-choice': VAdvertiserChoice,
	'v-mortgage': VMortgage,
	'v-map-google': VMapGoogle,
	'v-detail-specialist': VDetailSpecialist,
	'v-modal-select-multiple': VModalSelectMultiple,
	'v-modal-select': VModalSelect,
	'v-page-banner': VPageBanner,
	'v-internal-nav': VInternalNav,
	'v-profile': VProfile,
	'v-lk-ads': VLkAds,
	'v-ads': VAds,
	'v-page-header-lk': VPageHeaderLk,
	'v-lk-payment': VLkPayment,
	'v-payment': VPayment,
	'v-lk-notifications': VLkNotifications,
	'v-lk-payment-detail': VLkPaymentDetail,
	'v-catalog-specialist': VCatalogSpecialist,
	'v-radio-list': VRadioList,
	'v-ads-builder': VAdsBuilder,
	'v-confirm-location-modal': VConfirmLocationModal,
	'v-lk-employees': VLkEmployees,
	'v-lk-employees-card': VLkEmployeesCard,
	'v-not-found': VNotFound,
	'v-not-found-id': VNotFoundId,
	'v-confirm-modal': VConfirmModal,
	'v-add-contact-form': VAddContactForm,
	'v-modal-success': VModalSuccess,
	'v-cropp-image': VCroppImage,
	'v-map-filter': VMapFilter,
	'v-modal-map': VModalMap,
	'v-modal-cookie': VModalCookie,
	'v-mobile-nav-bar': VMobileNavBar
};